import React__default from 'react';

var ArticleDate = function ArticleDate(props) {
  var date = props.date;
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "article-date"
  }, date);
};

export { ArticleDate };
//# sourceMappingURL=article-date.esm.js.map
